<app-section-template
  [sectionTitle]="'Latest Deloitte publications'| translate">
  <div class="publications-container">
    @for (publication of data(); track publication.id) {
      <app-publication-card
        [publicationData]="publication"></app-publication-card>
    }
  </div>

  <app-see-all
    [url]="HELPER.getUrlFromMenu(E_FOLDER_TYPES.Publication)"
    seeAllText="See all publications"></app-see-all>
</app-section-template>
